export default "__VITE_ASSET__e81bfe8d__"